export default "__VITE_ASSET__cd75dd64__"